import { render, staticRenderFns } from "./concernedContactsWidget.vue?vue&type=template&id=672af2b8&scoped=true"
import script from "./concernedContactsWidget.vue?vue&type=script&lang=js"
export * from "./concernedContactsWidget.vue?vue&type=script&lang=js"
import style0 from "./concernedContactsWidget.vue?vue&type=style&index=0&id=672af2b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672af2b8",
  null
  
)

export default component.exports